import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from '../progressBar.component';
import { getJobProgress, isJobInProgress, getJobProgressMessage } from './helpers';
import { JobPropType } from './propTypes';

const JimProgressBar = ({
  job,
  className,
  text,
  forceShowProgressBar,
}) => {
  if (!isJobInProgress(job) && !forceShowProgressBar) {
    return null;
  }

  return (
    <ProgressBar
      progress={getJobProgress(job)}
      className={className}
      text={getJobProgressMessage(job) || text}
    />
  );
};

JimProgressBar.propTypes = {
  job: JobPropType,
  className: PropTypes.string,
  text: PropTypes.string,
  forceShowProgressBar: PropTypes.bool,
};

export default JimProgressBar;
